import { css } from '@emotion/core'
import { colors, spacing } from 'styles/variables'
import * as MQ from 'styles/media-queries'

export const bottomNav = css`
  position: fixed;
  bottom: 0;
  left: 0;
  right: 0;
  background-color: ${colors.black100};
  border-top: 1px solid ${colors.grays.gray7};
  z-index: 1000;
  
  /* Only show on mobile/tablet */
  display: block;
  ${MQ.NOT_TABLETS} {
    display: none;
  }
`

export const navContainer = css`
  display: flex;
  padding: ${spacing(2.8, 0, 2.8, 0)};
  max-width: 100%;
  margin: 0 auto;
  align-items: center;
  justify-content: space-around;
  position: relative;
`

export const navItem = css`
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: ${spacing(0.8)};
  padding: ${spacing(1.6, 0.4)};
  background: transparent;
  border: none;
  cursor: pointer;
  transition: all 0.2s ease;
  position: relative;
  
  &:hover {
    background-color: ${colors.grays.gray9};
  }
  
  &:focus {
    outline: none;
  }
`

export const navItemActive = css`
  /* Active state styling handled by icon and label styles */
`

export const iconContainer = css`
  display: flex;
  align-items: center;
  justify-content: center;
  width: ${spacing(5.44)};
  height: ${spacing(5.44)};
  margin: 0 auto;
  position: relative;
`

export const navIcon = css`
  width: ${spacing(5.28)};
  height: ${spacing(5.28)};
  color: ${colors.white60};
  fill: ${colors.white60};
  transition: color 0.2s ease;
  display: block;
  margin: 0 auto;
  
  /* Ensure SVG is perfectly centered */
  & svg {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 100%;
  }
`

export const navIconActive = css`
  color: ${colors.greens.green6};
  fill: ${colors.greens.green6};
  
  & svg {
    display: block;
    margin: 0 auto;
    width: 100%;
    height: 100%;
  }
`

export const eventIconLarger = css`
  width: ${spacing(4.928)} !important;
  height: ${spacing(4.928)} !important;
`

export const navLabel = css`
  color: ${colors.white60};
  text-align: center;
  line-height: 1;
  transition: color 0.2s ease;
  display: block;
  margin: 0 auto;
  
  /* Ensure text doesn't wrap */
  white-space: nowrap;
  font-size: 11px !important;
  font-weight: 500 !important;
  
  ${MQ.PHONES} {
    font-size: 9.9px !important;
  }
`

export const navLabelActive = css`
  color: ${colors.greens.green6};
` 